<h4>
    {{ date | dateTime : venue.timeZone : DateTime.DATE_FULL }}
    @if (serviceDescription) {
        - {{ serviceDescription.name }}
        ({{ serviceDescription.start | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }} -
        {{ serviceDescription.end | dateTime : venue.timeZone : DateTime.TIME_24_SIMPLE }})
    }
</h4>
<div>
    @if (aggregatedProducts.length === 0 && aggregatedModifiers.length === 0) {
        <p>No order items found for the selected criteria.</p>
    } @else {
        @if (aggregatedProducts.length > 0) {
            <h5 class="mt-4">Products</h5>
            <table class="table mb-5 pb-4 bookings-print-out">
                <colgroup>
                    <col>
                    <col>
                </colgroup>
                <thead>
                    <tr class="text-uppercase">
                        <th scope="col">Product</th>
                        <th scope="col">Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    @for (product of aggregatedProducts; track product.name) {
                        <tr>
                            <td>{{ product.name }}</td>
                            <td>{{ product.totalQuantity }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        }

        @if (aggregatedModifiers.length > 0) {
            <h5 class="mt-4">Modifiers</h5>
            <table class="table mb-5 pb-4 bookings-print-out">
                <colgroup>
                    <col>
                    <col>
                </colgroup>
                <thead>
                    <tr class="text-uppercase">
                        <th scope="col">Modifier</th>
                        <th scope="col">Quantity</th>
                    </tr>
                </thead>
                <tbody>
                    @for (modifier of aggregatedModifiers; track modifier.name) {
                        <tr>
                            <td>{{ modifier.name }}</td>
                            <td>{{ modifier.totalQuantity }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        }
    }
</div>
